; (function (inovestor, undefined) {
    // Setup dependencies for this plugin
    // Normally we would add jQuery and knockout but ms-core, which we depend on, already register them so it's useless

    // Create plugin namespace with any desired config variable
    inovestor.ms.stock = inovestor.ms.stock || {};
})(inovestor);


; (function (stock, undefined) {
    // Create plugin namespace with any desired config variable
    stock.dividends = {
        config: {
            apiRelativeUrl: 'stocks/dividendsOverview?symbol={symbol}'
        }
    };

})(inovestor.ms.stock);


; (function ($, ko, inovestor, undefined) {

    inovestor.ms.stock.dividends.viewModels = {};

    inovestor.ms.stock.dividends.viewModels.dividendsViewModel = function () {
        var dateTimeReviver = function (key, value) {
            var isoDateFormatRegex = /^\d{4}-(0[1-9]|1[0-2])-([12]\d|0[1-9]|3[01])([T\s](([01]\d|2[0-3])\:[0-5]\d|24\:00)(\:[0-5]\d([\.,]\d+)?)?([zZ]|([\+-])([01]\d|2[0-3])\:?([0-5]\d)?)?)?$/;

            if (typeof value === 'string') {
                var a = isoDateFormatRegex.exec(value);
                if (a) {
                    return new Date(value);
                }
            }

            return value;
        };

        var self = this;

        self.overview = ko.observable();
        self.payments = ko.observableArray();

        self.pageLimit = 20;
        self.currentPageIndex = ko.observable(0);
        self.currentPageItems = ko.pureComputed(function () {
            var startIndex = self.currentPageIndex() * self.pageLimit;
            return (self.payments() || []).slice(startIndex, startIndex + self.pageLimit);
        });
        self.currentPageInfo = ko.pureComputed(function () {
            var start = self.currentPageIndex() * self.pageLimit + 1;
            var end = self.currentPageIndex() * self.pageLimit + self.currentPageItems().length;
            var total = (self.payments() || []).length;
            return inovestor.ms.core.stringFormat(self.resources().pagination.paginationInfo, { start: start, end: end, total: total });
        });

        self.resources = ko.observable();
        self.hasError = ko.observable(false);
        self.isInvalidIdentifier = ko.observable(false);
        self.hasValidData = ko.computed(function () {
            return !self.hasError() && !self.isInvalidIdentifier() && self.overview() != null;
        }, this);

        self.setData = function (data) {
            // The sortable binding handler requires a Date instance to correctly sort a date.
            // So, in order to transform all date string to Date instance in the least painful way,
            // we stringify the javascript object and reparse it with our custom datetime parser.
            // It's probably too much...
            var stringifiedData = JSON.stringify(data);
            var model = JSON.parse(stringifiedData, dateTimeReviver);

            self.overview(model);
            // This only exists because the sortable binding handler needs an observable array.
            self.payments(model.dividendPayments);
            setupPagination(model.dividendPayments.length);
        };

        self.updateResources = function () {
            // Update main resources
            var currentResource = inovestor.ms.stock.dividends.resources[inovestor.ms.core.currentLanguage];
            if (inovestor.ms.core.isNullOrUndefined(currentResource))
                currentResource = null;
            self.resources(currentResource);
        };

        self.reset = function () {
            self.overview(null);
            self.payments(null);
            self.hasError(false);
            self.isInvalidIdentifier(false);
        };

        self.getFrequencyName = function (frequency) {
            switch (frequency) {
                case 'monthly':
                    return self.resources().frequencies.monthly;
                case 'quarterly':
                    return self.resources().frequencies.quarterly;
                case 'triAnnual':
                    return self.resources().frequencies.triAnnual;
                case 'semiAnnual':
                    return self.resources().frequencies.semiAnnual;
                case 'annual':
                    return self.resources().frequencies.annual;
                case 'unknown':
                    return '-';
                default:
                    return '-';
            }
        }

        function setupPagination(dataLength) {
            var $pagination = $('#payments-pagination');
            $pagination.twbsPagination('destroy');

            if (!dataLength || dataLength === 0)
                return;

            var numResults = dataLength;
            var numPages = numResults / self.pageLimit;
            if (numResults % self.pageLimit > 0)
                numPages++;

            if (self.currentPageIndex() > (numPages - 1))
                self.currentPageIndex(numPages - 1);

            $pagination.twbsPagination({
                totalPages: numPages,
                visiblePages: 5,
                initiateStartPageClick: false,
                startPage: self.currentPageIndex() + 1,
                first: self.resources().pagination.firstPage,
                prev: self.resources().pagination.previousPage,
                next: self.resources().pagination.nextPage,
                last: self.resources().pagination.lastPage,
                onPageClick: function (event, page) {
                    self.currentPageIndex(page - 1);
                }
            });
        }
    }

})(inovestor.ms.libRef.jQuery, inovestor.ms.libRef.ko, inovestor);
; (function ($, ko, inovestor, undefined) {

    var pluginName = 'inoMsStockDividends';

    // Create the plugin constructor
    function Plugin(element, options) {

        this.element = element;
        this._name = pluginName;
        this._defaults = $.fn.inoMsStockDividends.defaults;
        this._viewModel = new inovestor.ms.stock.dividends.viewModels.dividendsViewModel();

        // Merge options with defaults
        this.options = $.extend({}, this._defaults, options);

        // Make sure required variables are set
        if (inovestor.ms.core.isNullOrUndefined(this.options.symbol))
            throw "symbol is required";

        // Call init
        this.init();
    }

    $.extend(Plugin.prototype, {

        // Initialization logic
        init: function () {
            var plugin = this;

            // Setup what plugin needs to do on language change
            inovestor.ms.core.instances.register(this, function () {
                plugin.update();
            });

            // Plugin overrides for template = cacheKey and path are the same
            var fileCacheKey = plugin.options.templatePaths.dividends;
            var filePath = plugin.options.templatePaths.dividends;
            // Default behavior (if no template path is set by plugin)
            if (inovestor.ms.core.isEmptyString(fileCacheKey)) {
                var fileName = 'dividends.html';
                fileCacheKey = pluginName + '.' + fileName;
                filePath = (inovestor.ms.core.isEmptyString(inovestor.ms.core.config.templateRootUrl) ? '' : inovestor.ms.core.config.templateRootUrl) +
                    (inovestor.ms.core.isEmptyString(inovestor.ms.core.config.templateRootUrl) || inovestor.ms.core.config.templateRootUrl.match(/\/$/) != null ? '' : '/') + // check if templateRootUrl ends in slash
                    (this._name + '/' + fileName);
            }

            // Get main template file
            inovestor.ms.core.getTemplate(fileCacheKey, filePath).then(function (template) {
                $(plugin.element).html(template);
                plugin.buildCache();
                plugin.bindEvents();
                plugin.render();
                plugin.bindModel();
            }).then(function () {
                // Call Search
                plugin.search(plugin.options.symbol).always(function () {
                    // When search is completed, trigger onReady event
                    plugin.$element.trigger('ready' + '.' + plugin._name);
                });
            });
        },

        // Remove plugin instance completely
        destroy: function () {
            this.unbindEvents();
            this.$element.removeData();
        },

        // Cache DOM nodes for performance
        buildCache: function () {
            this.$element = $(this.element);
        },

        // Bind events that trigger methods
        bindEvents: function () {
            var plugin = this;
            plugin.$element.on('ready' + '.' + plugin._name, function () {
                var onReady = plugin.options.onReady;
                if (typeof onReady === 'function')
                    onReady.call(plugin.$element);
            });
        },

        // Unbind events that trigger methods
        unbindEvents: function () {
            this.$element.off('.' + this._name);
        },

        // API error handler
        apiErrorHandler: function (apiError) {
            var plugin = this;
            var onError = plugin.options.onError;
            if (typeof onError === 'function') {
                var result = onError.call(inovestor.ms.core.generateError(inovestor.ms.core.errors.apiError, apiError, plugin));
                // If callback returns false, do not execute default behavior
                if (!inovestor.ms.core.isNullOrUndefined(result) && result === false)
                    return;
            }

            plugin._viewModel.hasError(true);
        },

        // Invalid Identifier error handler
        invalidIdentifierHandler: function () {
            var plugin = this;
            var onError = plugin.options.onError;
            if (typeof onError === 'function') {
                var result = onError.call(inovestor.ms.core.generateError(inovestor.ms.core.errors.invalidIdentifier, null, plugin));
                // If callback returns false, do not execute default behavior
                if (!inovestor.ms.core.isNullOrUndefined(result) && result === false)
                    return;
            }

            plugin._viewModel.isInvalidIdentifier(true);
        },

        search: function (symbol) {
            var plugin = this;

            // Make sure required variables are set
            if (inovestor.ms.core.isNullOrUndefined(symbol))
                throw "symbol is required";

            // Update options
            plugin.options.symbol = symbol;

            // Setup API url with term
            var url = inovestor.ms.core.stringFormat(inovestor.ms.stock.dividends.config.apiRelativeUrl, { symbol: symbol });

            // Reset relevant Data before calling API
            plugin._viewModel.reset();

            // Call API and bind model
            var options = { type: 'GET', contentType: 'application/json', error: function (error) { plugin.apiErrorHandler(error); } };
            return inovestor.ms.core.ajaxApi(url, options).then(function (data) {
                if (!inovestor.ms.core.isNullOrUndefined(data)) {
                    if (data.requestStatus === 'invalidIdentifier')
                        plugin.invalidIdentifierHandler();

                    plugin._viewModel.setData(data);
                    plugin._renderChart(data);
                }

                plugin.update();
            });
        },

        // Renders html template and binds model (should be called once)
        render: function () {
            var plugin = this;
            plugin._viewModel.updateResources();
        },

        // Renders historical dividend chart
        _renderChart: function (data) {
            var plugin = this;
            var chartConfig = $.extend(true, {}, plugin.options.chartConfig);
            var chartData = data.dividendPayments.map(function (payment) {
                return [
                    new Date(payment.payDate).getTime(),
                    payment.amount
                ];
            });

            chartData.sort(function (a, b) {
                return a[0] - b[0];
            });

            chartConfig.series = [{
                name: 'Div.',
                data: chartData
            }];

            $("#dividends-history-chart-container").highcharts(chartConfig);
        },

        // Update resources
        update: function () {
            var plugin = this;
            plugin._viewModel.updateResources();
            //plugin._renderChart();
        },

        // Applies knockout bindings to element. (Should be done only once)
        bindModel: function () {
            var plugin = this;
            ko.applyBindings(plugin._viewModel, plugin.element);
        },
    });

    // JQuery Plugin wrapper
    $.fn.inoMsStockDividends = function (options) {
        this.each(function () {
            if (!$.data(this, pluginName)) {
                // Store instance of plugin in "$.data"
                $.data(this, pluginName, new Plugin(this, options));
            }
        });

        // return plugin to support JQuery chaining
        return this;
    };

    // Default options for plugin
    $.fn.inoMsStockDividends.defaults = {
        symbol: null,
        onError: null,
        onReady: null,
        templatePaths: {
            dividends: null
        },
        chartConfig: {
            chart: {
                type: 'column',
                height: 250
            },
            xAxis: {
                type: 'datetime'
            },
            legend: {
                enabled: false
            },
            plotOptions: {
                series: {
                    dataLabels: {
                        enabled: true,
                        format: '{point.y:.2f}'
                    }
                }
            },
            tooltip: {
                xDateFormat: '%Y-%m-%d',
                pointFormatter: function () {
                    return '<tr><td><span style=\'color: ' + this.series.color + '\'>●</span> ' + this.series.name + ': </td><td style=\'text-align: right;\'><b>' + ko.bindingHandlers.currency.format(this.y, true, true, false, 2) + '</b></td></tr>'
                }
            }
        }
    };

})(inovestor.ms.libRef.jQuery, inovestor.ms.libRef.ko, inovestor);
; (function (stock, undefined) {
    stock.dividends.resources = stock.dividends.resources || {};
    stock.dividends.resources["en"] = {
        amount: "Amount",
        dividendHistory: "Dividend History",
        dividendTtm: "Dividend (TTM)",
        dividendYieldTtm: "Dividend Yield (TTM)",
        exDate: "Ex-Dividend Date",
        frequencies: {
            annual: 'Annual',
            monthly: 'Monthly',
            quarterly: 'Quarterly',
            semiAnnual: 'Semiannual',
            triAnnual: 'Triannual'
        },
        nextDividend: "Next dividend",
        pagination: {
            paginationInfo: 'Showing {start} to {end} of {total} payments',
            nextPage: '<i class="fa fa-angle-right"></i>',
            previousPage: '<i class="fa fa-angle-left"></i>',
            firstPage: '<i class="fa fa-angle-double-left"></i>',
            lastPage: '<i class="fa fa-angle-double-right"></i>',
        },
        payDate: "Payable Date",
        payoutRatios: "Payout Ratios",
        payoutRatiosOnEarningsTtm: "Based on earnings (TTM)",
        payoutRatiosOnCashFlowTtm: "Based on cash flow (TTM)",
        period: "Period",
        recordDate: "Record Date"
    };
})(inovestor.ms.stock);

; (function (stock, undefined) {
    stock.dividends.resources = stock.dividends.resources || {};
    stock.dividends.resources["fr"] = {
        amount: "Montant",
        dividendHistory: "Historique des dividendes",
        dividendTtm: "Dividende (DDM)",
        dividendYieldTtm: "Rendement du div. (DDM)",
        exDate: "Date ex-dividende",
        frequencies: {
            annual: 'Annuelle',
            monthly: 'Mensuelle',
            quarterly: 'Trimestrielle',
            semiAnnual: 'Semestrielle',
            triAnnual: 'Quadrimestrielle'
        },
        nextDividend: "Prochain dividende",
        pagination: {
            paginationInfo: 'Affichage de {start} à {end} de {total} paiements',
            nextPage: '<i class="fa fa-angle-right"></i>',
            previousPage: '<i class="fa fa-angle-left"></i>',
            firstPage: '<i class="fa fa-angle-double-left"></i>',
            lastPage: '<i class="fa fa-angle-double-right"></i>',
        },
        payDate: "Date de paiment",
        payoutRatios: "Ratio de distribution",
        payoutRatiosOnEarningsTtm: "Basé sur les revenues (DDM)",
        payoutRatiosOnCashFlowTtm: "Basé sur le flux de trésorerie (DDM)",
        period: "Fréquence",
        recordDate: "Date d'enregistrement"
    };
})(inovestor.ms.stock);
